export default function About() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-20">
      <h1 className="mb-6 text-4xl font-bold">About GigVorx</h1>

      <p className="mb-6 text-lg leading-relaxed text-muted-foreground">
        GigVorx is a SaaS workspace for freelancers, agencies, and digital service
        providers who want clearer client communication and more professional project
        control.
      </p>

      <p className="mb-6 text-lg leading-relaxed text-muted-foreground">
        It helps you turn messy client conversations into clear briefs, approved
        scope, controlled revisions, invoices, follow-ups, and client records — all
        in one simple workspace.
      </p>

      <p className="mb-6 text-lg leading-relaxed text-muted-foreground">
        Version 0 focuses on the essentials: signup, dashboard, clients, leads,
        briefs, invoices, settings, pricing, mobile layout, empty states, and a
        7-day free trial for every new user.
      </p>

      <p className="text-lg leading-relaxed text-muted-foreground">
        Built for freelancers and agencies working globally, with pricing support for
        INR and USD.
      </p>
    </div>
  );
}